import { cva } from 'class-variance-authority';
import { TAG_TONE_THEME } from './theme';
import type { TagSize, TagTone, TagVariant } from './types';

const TONE_LIST = Object.keys(TAG_TONE_THEME) as TagTone[];
const VARIANT_LIST: TagVariant[] = ['soft', 'solid'];
export const tagCva = cva(
  'inline-flex select-none items-center gap-[2px] whitespace-nowrap rounded-full transition-colors',
  {
    variants: {
      variant: { soft: '', solid: '' } as Record<TagVariant, string>,
      tone: {
        mint: '',
        red: '',
        yellow: '',
        blue: '',
        gray: '',
        green: '',
        purple: '',
        black: '',
        emphasis: '',
        lightGray: '',
      } as Record<TagTone, string>,
      // 글꼴은 Label에서 Typography로 처리, 여기선 패딩/레디우스만
      size: {
        small: 'px-2 py-1', // C4_B
        medium: 'px-2 py-1', // C2_B
        large: 'px-3 py-1', // B4_B
      } as Record<TagSize, string>,
      disabled: { true: 'cursor-not-allowed opacity-60', false: '' },
    },
    compoundVariants: [
      ...TONE_LIST.flatMap((tone) =>
        VARIANT_LIST.map((variant) => ({
          tone,
          variant,
          class: `${TAG_TONE_THEME[tone][variant].text} ${TAG_TONE_THEME[tone][variant].bg}`,
        })),
      ),
    ],
    defaultVariants: { variant: 'soft', tone: 'gray', size: 'small' },
  },
);

export const tagIconCls = 'w-[14px] h-[14px] shrink-0';
